// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'

import {
  ExpandableOverviewItem,
  Button,
  SpanWithData,
  Warning
} from '../'

import { CreditAmountAppliedFor } from './CreditAmountAppliedFor'
import { ClientInformation } from './ClientInformation'

import { ReadOnlyContext } from '../../context'


export default class CreditApplicationInfo extends PureComponent {
  static propTypes = {
    identity: PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      identityType: PropTypes.string
    }).isRequired,
    employmentType: PropTypes.string.isRequired,
    preferredCallTime: PropTypes.string,
    preferredContactNumber: PropTypes.string,
    bankName: PropTypes.string,
    accountNumber: PropTypes.string,
    amountAppliedFor: PropTypes.string,
    updateCreditApplication: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  state = {
    amountAppliedFor: this.props.amountAppliedFor,
    amountsUpdateInProgress: false,
    amountsUpdateFail: false
  }

  hasAmountChanged = () => (
    parseFloat(this.state.amountAppliedFor) !== this.props.amountAppliedFor
  )

  saveAmountChanges = () => {
    this.setState({ amountsUpdateInProgress: true }, () => {
      let params = {}
      if (this.state.amountAppliedFor !== this.props.amountAppliedFor) {
        params.amountAppliedFor = this.state.amountAppliedFor
      }

      this.props.updateCreditApplication(params)
      .then(() => this.setState({ amountsUpdateInProgress: false }))
      .catch(() => this.setState({ amountsUpdateFail: true, amountsUpdateInProgress: false }))
    })
  }

  render() {
    let { identity, creditType, creditApplicationStatus, employmentType, preferredCallTime, preferredContactNumber, bankName, bankAccountNumber, open, onClick, className } = this.props
    let loanAppliedFor = this.state.amountAppliedFor

    return (
      <ExpandableOverviewItem
        title='Info'
        summary={identity
          ? <span>
              {`Application for ${identity.firstName} ${identity.lastName} - `}
              {['EXPIRED', 'CANCELLED'].indexOf(creditApplicationStatus) > -1
                ? <span className='slds-text-color_error'>{creditApplicationStatus}</span>
                : <SpanWithData forField='CreditApplicationStatus' searchKey={creditApplicationStatus} />
              }
            </span>
          : ''
        }
        iconSymbol={loanAppliedFor ? 'check' : 'warning'}
        iconColour={loanAppliedFor ? 'success' : 'warning'}
        open={open}
        onClick={onClick}
        className={className}>
        <div className='slds-p-right_medium slds-m-bottom_large'>
          <div className='slds-m-bottom_small slds-p-top_medium slds-p-bottom_medium'>
            <ReadOnlyContext.Consumer>
              {readOnly => (
                <Fragment>
                  <CreditAmountAppliedFor
                    amountAppliedFor={this.state.amountAppliedFor}
                    creditType={creditType}
                    changeAmountAppliedFor={e => this.setState({ amountAppliedFor: e.target.value })}
                    changeFailedFields={this.state.amountsUpdateFailFields}
                    changeSuccessFields={this.state.amountsUpdateSuccessFields}
                    readOnly={readOnly}
                  />
                  {!readOnly &&
                    <div className='slds-m-top_small slds-clearfix'>
                      <div className='slds-float_right'>
                        {this.state.amountsUpdateFail &&
                          <span className='slds-text-color_error'>
                            <Warning inline={true} iconSize='x-small' iconMargin='x-small'>
                              Saving of amount(s) edit failed.
                            </Warning>
                          </span>
                        }
                        <Button
                          type='brand'
                          minWidth={150}
                          disabled={!this.hasAmountChanged()}
                          onClick={this.saveAmountChanges}
                          className='slds-m-left_medium'>
                          {this.state.amountsUpdateInProgress
                            ? 'Saving...'
                            : 'Save'
                          }
                        </Button>
                      </div>
                    </div>
                  }
                </Fragment>
              )}
            </ReadOnlyContext.Consumer>
          </div>
          <ClientInformation
            name={`${identity.firstName} ${identity.lastName}`}
            id={
              <span>
                {`${identity.identityValue} (`}
                <SpanWithData forField='IdentityIdentityType' searchKey={identity.identityType} />
                {`)`}
              </span>
            }
            employmentType={employmentType}
            preferredCallTime={preferredCallTime}
            preferredContactNumber={preferredContactNumber}
            bankDetails={
              <span>
                {`${bankAccountNumber}  (`}
                <SpanWithData forField="BankAccountBankName" searchKey={bankName} />{')'}
              </span>
            }
          />
        </div>
      </ExpandableOverviewItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/creditapplication-info/index.js